import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './9d01f8c01e5aaac2a3ed387f64f25fba011f774f8cb30c1b7633ec93b2ffa929.cfe-internal.js';

var _excluded = ["className"];
var Divider = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("hr", _extends({
    ref: ref,
    className: classNames(className, styles.divider)
  }, rest));
});
Divider.propTypes = {
  className: PropTypes.string
};
var Divider$1 = Divider;

export { Divider$1 as default };
